import SectionMessage from '@atlaskit/section-message/message';
import * as React from 'react';
export default {
  SectionMessage,
  React
};